// extracted by mini-css-extract-plugin
export default {"backButtonContainer":"LoyaltyRewardsView_backButtonContainer__EXpDI","journeyContainer":"LoyaltyRewardsView_journeyContainer__hBcIX","error":"LoyaltyRewardsView_error__UBquv"};